var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, QueryList, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { config } from '../../../../config/config';
import { CreateEventCommand } from '../../../commands/hub/event/create.event.command';
import { ModalService } from '../../../common/services/modal.service';
import { HubEvent } from '../../../models/hub/hub.event';
import { HubVisitorPromotionImage } from '../../../models/hub/hub.visitor.promotion.image';
import { EventTimeService } from '../../../services/event.time.service';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ResizeImageModalComponent } from '../resize.image.modal/resize.image.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../show.info.modal/show.info.modal.provider';
import { EditEventModalActions } from './edit.event.modal.provider';
import { clone } from '../../../../../server/src/utils/object.extensions';
import { ResizeImageModalActions, ResizeImageModalData, } from '../resize.image.modal/resize.image.modal.provider';
import { ShowInfoModalComponent } from '../show.info.modal/show.info.modal.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { ToggleStore } from '../../../stores/hub.calendar.store';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { isNullOrUndefined } from '../../../common/extensions';
import { ShowImageModalComponent } from '../show.image.modal/show.image.modal.component';
import { ShowImageModalActions, ShowImageModalData, } from '../show.image.modal/show.image.modal.provider';
import * as jwt_decode from 'jwt-decode';
import { AlertifyService } from '../../../services/alertify.service';
var EditEventModalComponent = /** @class */ (function (_super) {
    __extends(EditEventModalComponent, _super);
    function EditEventModalComponent(dialogRef, actions, hubApiService, imageService, formBuilder, modalService, togglesStore, alertify, 
        // private scriptService: ScriptService,
        data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.imageService = imageService;
        _this.formBuilder = formBuilder;
        _this.modalService = modalService;
        _this.togglesStore = togglesStore;
        _this.alertify = alertify;
        _this.category = 'OTHER';
        _this.showTimezoneCitySelector = false;
        _this.isLoadingTimezone = false;
        _this.isUploadImage = false;
        _this.isShowMore = false;
        _this.isEditDescription = false;
        _this.isDescriptionNeedShowMore = false;
        _this.sizeLimit = config.eventImageSizeLimit;
        _this.frequencyItems = [];
        _this.frequencyEventTimes = [];
        _this.totalTimes = '';
        _this.dayInWeek = -1;
        _this.weekNo = -1;
        _this.frequency = 'event';
        _this.defaultEventTimes = [];
        _this.isAllowOnlineEvents = true;
        _this.isImageChanged = false;
        _this.hasCopyrights = false;
        _this.resizeImageTemp = null;
        _this.toggles = new HubVisitorFeatureToggle();
        _this.isRefreshingImage = false;
        _this.isGeneratingDescription = false;
        _this.aiGeneratedDescription = [];
        _this.firstTicketUri = '';
        _this.secondTicketUri = '';
        _this.visitorPromotionImage = new HubVisitorPromotionImage();
        _this.event = Object.assign({}, data);
        if (isNullOrUndefined(_this.event.owner)) {
            _this.event.owner = {
                name: '',
                id: '',
            };
        }
        _this.hubName = _this.event.hubName;
        if (!_this.event.eventTimes || !_this.event.eventTimes.length) {
            _this.event.eventTimes = [];
            _this.event.eventTimes.push({
                startTime: _this.event.startTime,
                endTime: _this.event.endTime,
            });
        }
        _this.event.timezoneFormatter =
            _this.event.timezoneFormatter ||
                (_this.event.timezone
                    ? EventTimeService.getTimezoneFormatterByTimezone(_this.event.timezone)
                    : EventTimeService.getTimezoneFormatter());
        if (_this.event.timezone && _this.event.timezone.startsWith('+')) {
            _this.event.timezone = null;
        }
        _this.event.timezone =
            _this.event.timezone ||
                EventTimeService.getTimezoneCodeByFormatter(_this.event.timezoneFormatter);
        _this.event.isNoTime = EventTimeService.isNoTimeEvent(_this.event);
        _this.defaultEventTimes = clone(_this.event.eventTimes);
        _this.createForm();
        _this.createEventCommand = new CreateEventCommand();
        _this.imageLink = _this.imageService.imageSource(_this.event);
        _this.imageWayChange();
        _this.event.imageFile = null;
        _this.resetFrequencyDropdown();
        // for no description event, enter the edit mode directly
        //this.isEditDescription = !this.event.description;
        _this.descriptionChange();
        _this.loadIsAllowOnlineEvents();
        _this.getToggles();
        _this.setUpHtmlEditor();
        _this.imageLink = _this.imageService.imageSource(_this.event);
        _this.originalImageLink = _this.imageLink;
        return _this;
    }
    EditEventModalComponent.prototype.setEventTime = function (time, timeRange) {
        if (time.startTime) {
            timeRange.startTime = time.startTime;
        }
        if (time.endTime) {
            timeRange.endTime = time.endTime;
        }
        if (this.frequency !== 'custom' && this.frequency !== 'event') {
            this.frequencySourceChange(this.frequency);
        }
    };
    EditEventModalComponent.prototype.showMore = function () {
        this.isShowMore = !this.isShowMore;
    };
    EditEventModalComponent.prototype.setUpHtmlEditor = function () {
        var _this = this;
        // set up the description HTML editor
        // http://suneditor.com/sample/html/examples.html
        // https://www.cssscript.com/tag/wysiwyg-editor/
        setTimeout(function () {
            _this.descriptionEditor = window['SUNEDITOR'].create('description-editor', {
                toolbarContainer: '#toolbar_container',
                showPathLabel: false,
                charCounter: true,
                // maxCharCount: 720,
                width: 'auto',
                // maxWidth: '700px',
                height: 'auto',
                minHeight: '100px',
                maxHeight: '250px',
                value: _this.event.description || '',
                buttonList: [
                    ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'],
                    [
                        'fontColor',
                        'hiliteColor',
                        'outdent',
                        'indent',
                        'align',
                        'horizontalRule',
                        'list',
                        'table',
                    ],
                    ['link', 'image', 'video', 'fullScreen', 'showBlocks', 'codeView', 'preview', 'print'],
                ],
            });
            _this.descriptionEditor.onImageUploadBefore = function (files, info, core, uploadHandler) {
                try {
                    _this.handleImageUploadBefore(files, info, uploadHandler);
                }
                catch (err) {
                    uploadHandler(err.toString());
                }
            };
        });
    };
    // public showHTML() {
    //   const myContent = window['tinymce'].activeEditor.getContent();
    //   console.log('myContent', myContent);
    //   this.removeHtmlEditor();
    //   this.event.description = myContent;
    //   this.isEditDescription = false;
    // }
    EditEventModalComponent.prototype.editDescription = function ($event) {
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.isEditDescription = !this.isEditDescription;
        // this.setHtmlEditor();
        this.descriptionChange();
    };
    EditEventModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    EditEventModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var linkHasChanged, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setEventTimes();
                        this.event.imageLink = this.imageLink;
                        this.event.title = this.event.name;
                        this.setEventLinks();
                        this.event.description = this.descriptionEditor.getContents();
                        linkHasChanged = (this.imageLink || '').trim() !== (this.originalImageLink || '').trim();
                        // Initialize cover object if needed
                        if (linkHasChanged || !this.event.cover) {
                            this.event.cover = {
                                source: this.imageLink,
                                isLarge: true,
                            };
                        }
                        if (!(this.resizeImageTemp ||
                            (linkHasChanged &&
                                this.imageLink &&
                                (!this.imageLink.startsWith('https://iti-images.s3.amazonaws.com') ||
                                    this.imageLink.indexOf('.webp') < 0)))) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(this.resizeImageTemp || this.imageLink, 1200)];
                    case 2:
                        res = _a.sent();
                        if (res.success) {
                            // Ensure cover object exists and update with AWS URL
                            if (this.event.cover) {
                                this.event.cover = { isLarge: true };
                            }
                            this.event.cover.source = this.imageLink = this.event.imageLink = res.url;
                        }
                        else {
                            // Handle upload failure
                            console.error('AWS upload failed:', res);
                            this.alertify.warning('🚨 Failed to upload image. Please try to download the image and upload from your computer.');
                            return [2 /*return*/]; // Don't proceed with event update if upload failed
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error uploading to AWS:', error_1);
                        return [2 /*return*/]; // Don't proceed with event update if upload failed
                    case 4:
                        // Handle address components
                        if (this.event.address &&
                            this.event.address.address_components &&
                            this.event.address.address_components.length > 0) {
                            this.event.address.addressComponents = clone(this.event.address.address_components);
                            this.event.address.address_components = null;
                        }
                        this.hubApiService
                            .updateEvent(this.hubName, this.event._id, this.event)
                            .subscribe(function (newEvent) {
                            _this.event = newEvent;
                            EventTimeService.processEventTime(_this.event);
                            _this.actions.confirm(event, _this.event, !_this.isUploadImage ? _this.imageLink : newEvent.cover.source);
                            if (!window.location.href.includes('localhost')) {
                                var authToken = localStorage.getItem(localStorageKeys.authToken);
                                var tokenInfo = jwt_decode(authToken);
                                try {
                                    var trackName = 'editEvent - ' + _this.event.name;
                                    window['pendo'].track(trackName, {
                                        accountId: tokenInfo.userName,
                                        timestamp: Date.now(),
                                        hubName: _this.hubName,
                                    });
                                }
                                catch (error) {
                                    console.error(error);
                                }
                            }
                            _this.dialogRef.close();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    EditEventModalComponent.prototype.showChangeHistory = function () {
        var text = [];
        this.event.changeHistory.forEach(function (x, i) {
            text.push(++i + ". Changed by: " + x.userName + ", at " + new Date(x.changedAt).toLocaleString() + " ");
        });
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData('Result', [], text.length ? text : ['(No records)']),
                },
            ],
            panelClass: 'width-modal-3',
        });
    };
    EditEventModalComponent.prototype.citySelected = function () {
        var _this = this;
        if (this.timezoneAddress) {
            this.isLoadingTimezone = true;
            this.hubApiService
                .getTimezoneByLatlng(this.timezoneAddress.lat, this.timezoneAddress.lng)
                .finally(function () {
                _this.isLoadingTimezone = false;
            })
                .subscribe(function (data) {
                console.log(data.abbreviation);
                _this.event.timezone = data.abbreviation;
                _this.event.timezoneFormatter = EventTimeService.getTimezoneFormatterByTimezone(_this.event.timezone);
                _this.dateTimeInput.toArray().forEach(function (x) {
                    x.timeFormatter = _this.event.timezoneFormatter;
                    x.timezone = _this.event.timezone;
                    x.setTime('start');
                    x.setTime('end');
                });
            });
        }
    };
    EditEventModalComponent.prototype.addTimeRange = function () {
        this.event.eventTimes.push({});
    };
    EditEventModalComponent.prototype.removeTimeRange = function (i) {
        this.event.eventTimes.splice(i, 1);
    };
    EditEventModalComponent.prototype.descriptionChange = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.descriptionArea && _this.descriptionArea.nativeElement) {
                _this.descriptionArea.nativeElement.style.height =
                    Math.min(_this.descriptionArea.nativeElement.scrollHeight, 300) + 'px';
            }
            if (_this.descriptionHtml) {
                _this.isDescriptionNeedShowMore = _this.descriptionHtml.nativeElement.scrollHeight > 150;
            }
        });
    };
    EditEventModalComponent.prototype.loadIsAllowOnlineEvents = function () {
        var settingsStr = localStorage.getItem(localStorageKeys.allBackendSettings);
        if (settingsStr) {
            var settings = JSON.parse(settingsStr);
            var customSettings = settings.customSettings;
            this.isAllowOnlineEvents = customSettings.isAllowOnlineEvents;
        }
    };
    EditEventModalComponent.prototype.getToggles = function () {
        var _this = this;
        this.togglesStore.toggleCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (toggleCommand) {
            _this.toggles =
                isNullOrUndefined(toggleCommand) || isNullOrUndefined(toggleCommand.placeCalendar)
                    ? new HubVisitorFeatureToggle()
                    : toggleCommand;
        });
    };
    EditEventModalComponent.prototype.imageWayChange = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.isUploadImage) {
                if (_this.mask) {
                    _this.mask.nativeElement.style.height = '40px';
                    _this.mask.nativeElement.style.cursor = 'pointer';
                    _this.mask.nativeElement.style.backgroundColor = 'black';
                    // this.mask.nativeElement.style.top = this.imgEle.nativeElement.height - 10 + 'px';
                    _this.mask.nativeElement.style.top = '35px';
                }
                if (_this.upload) {
                    _this.upload.nativeElement.style.cursor = 'pointer';
                    _this.upload.nativeElement.style.backgroundColor = '#D3D0D0';
                }
            }
            else {
                _this.selectedImageData = null;
                _this.resizeImageTemp = null;
                if (_this.mask) {
                    _this.mask.nativeElement.style.height = _this.imgEle.nativeElement.height + 'px';
                    _this.mask.nativeElement.style.cursor = 'default';
                    _this.mask.nativeElement.style.backgroundColor = 'gray';
                    _this.mask.nativeElement.style.top = '30px';
                }
                if (_this.upload) {
                    _this.upload.nativeElement.style.cursor = 'default';
                    _this.upload.nativeElement.style.backgroundColor = '#ececec';
                }
            }
        });
    };
    EditEventModalComponent.prototype.onImageChange = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var reader, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.selectedImageFile = $event.srcElement.files[0];
                        if (!!!this.selectedImageFile) return [3 /*break*/, 4];
                        reader = new FileReader();
                        reader.onload = function (e) {
                            _this.selectedImageData = e.target['result'];
                            // this.event.imageFile = this.selectedImageFile;
                            _this.imageWayChange();
                        };
                        reader.readAsDataURL(this.selectedImageFile);
                        // this.event.imageFile = await this.imageService.compressImageFile(this.selectedImageFile, config.compressImgWidth);
                        _a = this;
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(this.selectedImageFile, config.compressImgWidth)];
                    case 1:
                        // this.event.imageFile = await this.imageService.compressImageFile(this.selectedImageFile, config.compressImgWidth);
                        _a.resizeImageTemp = _c.sent();
                        if (!(this.resizeImageTemp.length > 1000000)) return [3 /*break*/, 3];
                        _b = this;
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(this.selectedImageFile, config.compressImgWidth - 200)];
                    case 2:
                        _b.resizeImageTemp = _c.sent();
                        _c.label = 3;
                    case 3:
                        this.isImageChanged = true;
                        _c.label = 4;
                    case 4:
                        $event.target.value = '';
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(EditEventModalComponent.prototype, "isFormInvalid", {
        get: function () {
            return (!this.event.name ||
                (!this.event.address && !this.event.isOnlineEvent) ||
                !this.event.owner.name ||
                !this.event.eventTimes ||
                !this.event.eventTimes.length ||
                (this.isImageChanged && !this.hasCopyrights));
        },
        enumerable: true,
        configurable: true
    });
    EditEventModalComponent.prototype.virtualEventChange = function () {
        if (this.event.isOnlineEvent) {
            this.event.isHybridEvent = false;
        }
    };
    EditEventModalComponent.prototype.hybridEventChange = function () {
        if (this.event.isHybridEvent) {
            this.event.isOnlineEvent = false;
        }
    };
    Object.defineProperty(EditEventModalComponent.prototype, "addressInputLabel", {
        get: function () {
            if (!this.isAllowOnlineEvents) {
                return "Location / Address *";
            }
            return "Location / Address " + (this.event.isOnlineEvent ? '' : '*') + " (or check Virtual Events)";
        },
        enumerable: true,
        configurable: true
    });
    EditEventModalComponent.prototype.setFrequencyDropdown = function () {
        if (this.event.eventTimes.length > 0) {
            this.setDefaultTimeValue();
        }
        this.frequencyItems = this.frequencyItems.filter(function (x) { return x.value !== 'last'; });
        var start = this.event.eventTimes[0].startTime;
        this.dayInWeek = EventTimeService.getDayOfWeek(start, this.event.timezone);
        var dayText = config.dayOfWeek[this.dayInWeek].name;
        var weekly = this.frequencyItems.first(function (x) { return x.value === 'weekly'; });
        if (weekly) {
            weekly.text = "Weekly on " + dayText;
        }
        var biWeekly = this.frequencyItems.first(function (x) { return x.value === 'biweekly'; });
        if (biWeekly) {
            biWeekly.text = "Every Other " + dayText + " (starts from " + EventTimeService.getDayAndMonth(start, this.event.timezone) + ")";
        }
        var monthly = this.frequencyItems.first(function (x) { return x.value === 'monthly'; });
        if (monthly) {
            var no = EventTimeService.getWeekDayNo(start, this.event.timezone);
            if (!no.isLast) {
                this.weekNo = no.no;
                monthly.text = "Monthly on the " + no.text + " " + dayText;
                monthly.value = 'monthly';
            }
            else if (no.isLast && no.text === 'last') {
                monthly.text = "Monthly on the last " + dayText;
                monthly.value = 'last';
            }
            else if (no.isLast && no.text !== 'last') {
                this.weekNo = no.no;
                monthly.text = "Monthly on the " + no.text + " " + dayText;
                monthly.value = 'monthly';
                this.frequencyItems.push({
                    value: 'last',
                    text: "Monthly on the last " + dayText,
                });
            }
        }
    };
    EditEventModalComponent.prototype.frequencySourceChange = function (target) {
        var _this = this;
        this.frequency = target.value || target;
        var start = this.event.eventTimes[0].startTime;
        var end = this.event.eventTimes[0].endTime;
        // end = EventTimeService.addHours(new Date(end), -1);
        var eventTimes = [], days = [];
        var diff = 0;
        var scrossDaylight = '';
        if (this.frequency === 'event') {
            this.event.eventTimes = clone(this.defaultEventTimes);
            return;
        }
        else {
            this.event.eventTimes = [this.event.eventTimes[0]];
        }
        switch (this.frequency) {
            case 'daily':
                diff = EventTimeService.diff(start, end);
                this.totalTimes = diff + 1 + " Dates " + EventTimeService.getDayAndMonth(start, this.event.timezone) + " - " + EventTimeService.getDayAndMonth(end, this.event.timezone);
                for (var i = 0; i <= diff; i++) {
                    var startTime = EventTimeService.addHours(new Date(start), 24 * i);
                    var time = this.adjustForDaylightSaving(start, end, startTime);
                    this.setTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                }
                if (scrossDaylight === 'ST') {
                    for (var _i = 0, eventTimes_1 = eventTimes; _i < eventTimes_1.length; _i++) {
                        var time = eventTimes_1[_i];
                        time.endTime = EventTimeService.addHours(time.endTime, -1);
                    }
                }
                if (scrossDaylight === 'DT') {
                    for (var _a = 0, eventTimes_2 = eventTimes; _a < eventTimes_2.length; _a++) {
                        var time = eventTimes_2[_a];
                        time.endTime = EventTimeService.addHours(time.endTime, 1);
                    }
                }
                break;
            case 'weekly':
                diff = EventTimeService.diff(start, end, 'weeks');
                this.totalTimes = diff + 1 + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.event.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.event.timezone);
                for (var i = 0; i <= diff; i++) {
                    var startTime = EventTimeService.addHours(new Date(start), 24 * 7 * i);
                    var time = this.adjustForDaylightSaving(start, end, startTime);
                    this.setTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                }
                if (scrossDaylight === 'ST') {
                    for (var _b = 0, eventTimes_3 = eventTimes; _b < eventTimes_3.length; _b++) {
                        var time = eventTimes_3[_b];
                        time.endTime = EventTimeService.addHours(time.endTime, -1);
                    }
                }
                if (scrossDaylight === 'DT') {
                    for (var _c = 0, eventTimes_4 = eventTimes; _c < eventTimes_4.length; _c++) {
                        var time = eventTimes_4[_c];
                        time.endTime = EventTimeService.addHours(time.endTime, 1);
                    }
                }
                break;
            case 'biweekly':
                diff = EventTimeService.diff(start, end, 'biweekly');
                this.totalTimes = diff + 1 + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.event.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.event.timezone);
                for (var i = 0; i <= diff; i++) {
                    var startTime = EventTimeService.addHours(new Date(start), 24 * 14 * i);
                    var time = this.adjustForDaylightSaving(start, end, startTime);
                    this.setTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                }
                if (scrossDaylight === 'ST') {
                    for (var _d = 0, eventTimes_5 = eventTimes; _d < eventTimes_5.length; _d++) {
                        var time = eventTimes_5[_d];
                        time.endTime = EventTimeService.addHours(time.endTime, -1);
                    }
                }
                if (scrossDaylight === 'DT') {
                    for (var _e = 0, eventTimes_6 = eventTimes; _e < eventTimes_6.length; _e++) {
                        var time = eventTimes_6[_e];
                        time.endTime = EventTimeService.addHours(time.endTime, 1);
                    }
                }
                break;
            case 'monthly':
                days = EventTimeService.getSameDayInWeek(start, end, this.dayInWeek, this.weekNo, this.event.timezone);
                this.totalTimes = days.length + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.event.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.event.timezone);
                days.forEach(function (x) {
                    var time = _this.adjustForDaylightSaving(start, end, x);
                    _this.setTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                });
                break;
            case 'last':
                days = EventTimeService.getLastWeekDays(start, end, this.dayInWeek, this.event.timezone);
                this.totalTimes = days.length + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.event.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.event.timezone);
                days.forEach(function (x) {
                    var time = _this.adjustForDaylightSaving(start, end, x);
                    _this.setTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                });
                if (scrossDaylight === 'ST') {
                    for (var _f = 0, eventTimes_7 = eventTimes; _f < eventTimes_7.length; _f++) {
                        var time = eventTimes_7[_f];
                        time.endTime = EventTimeService.addHours(time.endTime, -1);
                    }
                }
                if (scrossDaylight === 'DT') {
                    for (var _g = 0, eventTimes_8 = eventTimes; _g < eventTimes_8.length; _g++) {
                        var time = eventTimes_8[_g];
                        time.endTime = EventTimeService.addHours(time.endTime, 1);
                    }
                }
                break;
            default:
                break;
        }
        this.frequencyEventTimes = eventTimes;
    };
    EditEventModalComponent.prototype.imageResized = function (imgBase64) {
        this.resizeImageTemp = imgBase64;
    };
    EditEventModalComponent.prototype.resizeImage = function ($event) {
        var _this = this;
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        var actions = {
            confirm: function (event, image) {
                !!image && (_this.resizeImageTemp = image);
            },
        };
        var data = {
            data: this.resizeImageTemp || this.imageLink || this.event.cover.source,
        };
        this.modalService.show({
            component: ResizeImageModalComponent,
            providers: [
                { provide: ResizeImageModalActions, useValue: actions },
                { provide: ResizeImageModalData, useValue: data },
            ],
            panelClass: 'width-modal-2',
        });
    };
    EditEventModalComponent.prototype.refreshImage = function () {
        var _this = this;
        this.isRefreshingImage = true;
        this.hubApiService
            .refreshEventImage(this.hubName, this.event._id)
            .finally(function () { return (_this.isRefreshingImage = false); })
            .subscribe(function (data) {
            if (!data.success) {
                alert("Unable to refresh this image, reason: " + data.error);
                return;
            }
            if (data && data.image) {
                var actions = {
                    confirm: function (event, image) {
                        if (image) {
                            _this.imageLink = image;
                        }
                    },
                };
                _this.modalService.show({
                    component: ShowImageModalComponent,
                    providers: [
                        { provide: ShowImageModalActions, useValue: actions },
                        {
                            provide: ShowImageModalData,
                            useValue: {
                                data: data.image,
                            },
                        },
                    ],
                    panelClass: 'width-modal-2',
                });
            }
        });
    };
    EditEventModalComponent.prototype.generateDescription = function () {
        var _this = this;
        if (this.isGeneratingDescription)
            return;
        this.isGeneratingDescription = true;
        // this.aiGeneratedDescription = [];
        this.hubApiService
            .aiAssistant(this.hubName, {
            query: this.getEventInfoForGeneratingDescription(),
            model: 'chatgpt',
            feature: 'event-description',
        })
            .finally(function () {
            _this.isGeneratingDescription = false;
        })
            .subscribe(function (data) {
            if (data.success) {
                try {
                    var json = JSON.parse(data.data);
                    _this.aiGeneratedDescription = [json.version1, json.version2, json.version3];
                    console.log(_this.aiGeneratedDescription);
                    var modal = document.querySelector('.ig-edit-event-modal');
                    modal &&
                        (modal.className = modal.className.replace('width-modal-2', 'width-modal-70p'));
                    _this.trackEventAIContentAssistant();
                }
                catch (err) {
                    console.error(err);
                }
            }
        });
    };
    EditEventModalComponent.prototype.selectDescription = function (description) {
        var _this = this;
        if (this.isRegeneratingDescription)
            return;
        this.event.description = description;
        if (this.descriptionHtml) {
            this.descriptionHtml.nativeElement.classList.remove('ig-fade-in');
            this.descriptionHtml.nativeElement.style.height = '130px';
            setTimeout(function () {
                _this.descriptionHtml.nativeElement.classList.add('ig-fade-in');
            });
        }
        if (this.descriptionArea) {
            this.descriptionArea.nativeElement.classList.remove('ig-fade-in');
            this.descriptionArea.nativeElement.style.height = '130px';
            setTimeout(function () {
                _this.descriptionArea.nativeElement.classList.add('ig-fade-in');
            });
        }
        if (this.descriptionEditor) {
            this.descriptionEditor.setContents(description);
        }
    };
    Object.defineProperty(EditEventModalComponent.prototype, "isRegeneratingDescription", {
        get: function () {
            return this.aiGeneratedDescription.length && this.isGeneratingDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditEventModalComponent.prototype, "isNormalTicketUri", {
        get: function () {
            if (!this.event)
                return false;
            return !!(this.event.ticketUri &&
                (!this.event.ticketInfo ||
                    !this.event.ticketInfo.length ||
                    this.event.ticketUri !== this.event.ticketInfo[0].link));
        },
        enumerable: true,
        configurable: true
    });
    EditEventModalComponent.prototype.trackEventAIContentAssistant = function () {
        if (!window.location.href.includes('localhost')) {
            var authToken = localStorage.getItem(localStorageKeys.authToken);
            var tokenInfo = jwt_decode(authToken);
            try {
                var trackName = 'click - Event - AIContentAssistant - ' + this.event.name;
                window['pendo'].track(trackName, {
                    accountId: tokenInfo.userName,
                    timestamp: Date.now(),
                    hubName: this.hubName,
                });
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    EditEventModalComponent.prototype.getEventInfoForGeneratingDescription = function () {
        return "event title: " + this.event.name + "; address: " + (this.event.address ? this.event.address.address : '') + "; venue/host: " + (this.event.venue || (this.event.venueInfo ? this.event.venueInfo.name : this.event.owner.name));
    };
    EditEventModalComponent.prototype.adjustForDaylightSaving = function (start, end, nextDayStart) {
        var formatter = EventTimeService.getTimezoneFormatterByTimezone(this.event.timezone);
        var startTimezone = EventTimeService.getTimezonecodeWithTimeSaving(start, formatter);
        var nextDayTimezone = EventTimeService.getTimezonecodeWithTimeSaving(nextDayStart, formatter);
        var scrossDaylight = '';
        var thisEnd = end;
        if (startTimezone !== nextDayTimezone) {
            if (nextDayTimezone.indexOf('ST') >= 0) {
                nextDayStart = EventTimeService.addHours(nextDayStart, 1);
                thisEnd = EventTimeService.addHours(thisEnd, 1);
                scrossDaylight = 'ST';
            }
            else {
                nextDayStart = EventTimeService.addHours(nextDayStart, -1);
                thisEnd = EventTimeService.addHours(thisEnd, -1);
                scrossDaylight = 'DT';
            }
        }
        return {
            startTime: nextDayStart,
            endTime: thisEnd,
            scrossDaylight: scrossDaylight,
        };
    };
    EditEventModalComponent.prototype.setTimes = function (start, end, eventTimes) {
        var startTime = start;
        var endTime = new Date(new Date(startTime).setUTCHours(new Date(end).getUTCHours()));
        endTime = new Date(endTime.setUTCMinutes(new Date(end).getUTCMinutes()));
        if (endTime < new Date(startTime)) {
            endTime = new Date(EventTimeService.addHours(endTime, 24));
        }
        eventTimes.push({
            startTime: startTime,
            endTime: endTime.toISOString(),
        });
        console.log('eventTimes', eventTimes);
    };
    EditEventModalComponent.prototype.setDefaultTimeValue = function () {
        var endPlusHours = 0;
        switch (this.frequency) {
            case 'custom':
                endPlusHours = 24 + 3;
                break;
            case 'daily':
                endPlusHours = 24 * 7 + 3;
                break;
            case 'weekly':
                endPlusHours = 24 * 365 + 3;
                break;
        }
        if (!this.event.eventTimes[0].startTime && !this.event.eventTimes[0].endTime) {
            this.event.eventTimes = [
                {
                    startTime: EventTimeService.getDefaultStartTime(this.event.timezone),
                    endTime: EventTimeService.addHours(EventTimeService.getDefaultStartTime(this.event.timezone), endPlusHours),
                },
            ];
        }
        else if (this.event.eventTimes[0].startTime && !this.event.eventTimes[0].endTime) {
            this.event.eventTimes = [
                {
                    startTime: this.event.eventTimes[0].startTime,
                    endTime: EventTimeService.addHours(new Date(this.event.eventTimes[0].startTime), 24 * 7),
                },
            ];
        }
        else if (!this.event.eventTimes[0].startTime && this.event.eventTimes[0].endTime) {
            this.event.eventTimes = [
                {
                    startTime: EventTimeService.addHours(new Date(this.event.eventTimes[0].startTime), 24 * 7 * -1),
                    endTime: this.event.eventTimes[0].endTime,
                },
            ];
        }
    };
    EditEventModalComponent.prototype.resetFrequencyDropdown = function () {
        this.frequencyItems = [
            {
                text: 'Current event times',
                value: 'event',
                selected: true,
            },
            {
                text: 'Custom',
                value: 'custom',
            },
            {
                text: 'Daily',
                value: 'daily',
            },
            {
                text: 'Weekly',
                value: 'weekly',
            },
            {
                text: 'Biweekly',
                value: 'biweekly',
            },
            {
                text: 'Monthly',
                value: 'monthly',
            },
        ];
    };
    EditEventModalComponent.prototype.setEventTimes = function () {
        this.event.startTime = this.event.eventTimes[0].startTime;
        this.event.endTime = this.event.eventTimes[this.event.eventTimes.length - 1].endTime
            ? this.event.eventTimes[this.event.eventTimes.length - 1].endTime
            : null;
        if (this.frequency !== 'custom' && this.frequency !== 'event') {
            this.event.eventTimes = this.frequencyEventTimes;
        }
        this.event.eventTimes.forEach(function (x) {
            x.startTimeFormatted = undefined;
            x.endTimeFormatted = undefined;
            x.startTimeText = undefined;
            x.endTimeText = undefined;
        });
        this.event.eventTimesText = [];
        this.event.startTimeFormatted = undefined;
        this.event.endTimeFormatted = undefined;
        this.event.startTimeText = undefined;
        this.event.endTimeText = undefined;
    };
    EditEventModalComponent.prototype.setEventLinks = function () {
        this.event.eventLink = this.event.eventLink
            ? this.event.eventLink.startsWith('http')
                ? this.event.eventLink
                : "https://" + this.event.eventLink
            : '';
        this.event.hostLink = this.event.hostLink
            ? this.event.hostLink.startsWith('http')
                ? this.event.hostLink
                : "https://" + this.event.hostLink
            : '';
        this.event.ticketUri = this.event.ticketUri
            ? this.event.ticketUri.startsWith('http')
                ? this.event.ticketUri
                : "https://" + this.event.ticketUri
            : '';
        // only take the 2 ticket urls (there might be more than 2 for existing serp google events, but also have restricted to get only 2 now)
        if (this.event.ticketInfo && this.event.ticketInfo.length) {
            var ticketInfo = [];
            for (var _i = 0, _a = this.event.ticketInfo.slice(0, 2); _i < _a.length; _i++) {
                var x = _a[_i];
                x.link && ticketInfo.push(x);
            }
            this.event.ticketInfo = ticketInfo;
            this.event.ticketUri = '';
        }
    };
    EditEventModalComponent.prototype.createForm = function () {
        this.createEventForm = this.formBuilder.group({
            name: [null, [Validators.required]],
            description: [null, []],
            timeRanges: this.formBuilder.array([]),
            address: [null, [Validators.required]],
            host: [null, [Validators.required]],
            category: [null, [Validators.required]],
            ticketUri: [null, []],
            ticketUri2: [null, []],
            facebookEvent: [null, []],
            hostLink: [null, []],
            eventLink: [null, []],
            imageLink: [null, []],
            timezone: [null, []],
            venue: [null, []],
            organizerEmail: [null, []],
        });
    };
    EditEventModalComponent.prototype.handleImageUploadBefore = function (files, info, uploadHandler) {
        var _this = this;
        this.imageService
            .getBase64ByImageFile(files[0])
            .then(function (imageInfo) {
            if (imageInfo) {
                _this.hubApiService
                    .uploadBase64ImageToAWS(imageInfo)
                    .then(function (res) {
                    if (res.success) {
                        var response = {
                            result: [
                                {
                                    url: "" + res.url,
                                    name: files[0].name,
                                    size: files[0].size,
                                },
                            ],
                        };
                        uploadHandler(response);
                    }
                    else {
                        uploadHandler('upload image fail');
                    }
                })
                    .catch(function (err) {
                    uploadHandler('upload image fail');
                    console.error(err);
                });
            }
        })
            .catch(function (err) {
            console.error(err);
        });
    };
    EditEventModalComponent.prototype.handleImageLinkChange = function (value) {
        this.imageLink = value;
        // compare the *trimmed* current value with the original one
        var current = (this.imageLink || '').trim();
        var original = (this.originalImageLink || '').trim();
        this.isImageChanged = current !== original;
    };
    return EditEventModalComponent;
}(BaseComponent));
export { EditEventModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.event.modal/edit.event.modal.component.ts.pre-build-optimizer.js